<template>
  <BaseCard :outlined="!$vuetify.breakpoint.xs" class="rounded-2">
    <ExperienceCardHeader
      v-if="post.type !== 'picture_post'"
      :username="post.creator.user"
      :avatarPicture="
        post.creator.profilePicture ? post.creator.profilePicture.small : ''
      "
      :season="post.season"
      :postIsEditable="postIsEditable"
      @manage-post="$store.dispatch('share/manageSharePost', post)"
    ></ExperienceCardHeader>
    <div
      class="relative"
      v-bind:class="{ 'px-6 pt-6 pb-4': post.type == 'picture_post' }"
    >
      <BaseSheet
        class="image-wrapper"
        v-bind:class="{ 'rounded-1': post.type == 'picture_post' }"
        color="grey lighten-1"
        style="overflow:hidden"
      >
        <BaseCarousel
          v-if="!!post.pictures.length"
          :pictures="post.pictures"
          :link="post.type !== 'short_post' ? post.url : ''"
          @change="changeActivePicture($event + 1)"
          :continuous="false"
          class="image-wrapper-content"
        ></BaseCarousel>
        <div v-else>
          <a v-if="post.type !== 'short_post'" :href="post.url" target="blank">
            <BaseImage
              :src="require('@/assets/defaultCardPicture.png')"
              class="image-wrapper-content"
            ></BaseImage>
          </a>
          <BaseImage
            v-else
            :src="require('@/assets/defaultCardPicture.png')"
            class="image-wrapper-content"
          ></BaseImage>
        </div>
        <div v-if="post.type == 'youtube'" class="absolute top-0 right-0 pa-4">
          <BaseButton
            @click="playYoutubeVideo()"
            :small="true"
            :depressed="true"
            color="white"
          >
            Lire la vidéo
          </BaseButton>
        </div>
        <youtube-media
          v-show="isYoutubePlayerDisplayed"
          v-if="post.type === 'youtube'"
          @ready="youtubeVideoIsReady"
          @paused="youtubeVideoHasBeenPaused"
          :video-id="this.post.url.slice(this.post.url.indexOf('=') + 1)"
          player-width="100%"
          player-height="100%"
          :player-vars="{
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            origin: origin,
            controls: 0,
            fs: 0,
            autoplay: 0,
            playsinline: 1
          }"
          host="https://www.youtube-nocookie.com"
          class="absolute top-0 bottom-0 left-0 right-0"
        ></youtube-media>
      </BaseSheet>
      <div
        v-if="post.type == 'picture_post'"
        class="absolute full--width"
        style="bottom: 0px; left:16px; max-width: calc(100% - 52px)"
      >
        <div class="relative">
          <BaseSheet
            height="32px"
            class="rounded-4 px-4 d-flex align-center relative z-index-1"
            color="white"
            :elevation="2"
          >
            <div class="d-flex align-center full--width">
              <BaseIcon :size="16" class="mr-2 primary--text flex-shrink-0">
                {{
                  `$${
                    post.destinations[0].category
                      ? post.destinations[0].category.nameEn
                      : "poi"
                  }` | noSpace
                }}
              </BaseIcon>
              <div
                v-text="post.destinations[0].location.properties.longName"
                class=" flex-shrink-1 text-subtitle-2 font-weight-regular primary--text text-truncate"
              ></div>
            </div>
          </BaseSheet>
          <div
            v-if="post.pictures[activePicturePosition - 1].caption"
            class="absolute full--width"
            style="left:8px ; bottom:32px;"
          >
            <BaseSheet
              color="#00000099"
              height="24px"
              class="rounded-t-3 px-2 d-flex align-center"
              style="max-width: calc(100% - 32px);"
              width="max-content"
            >
              <div
                v-text="post.pictures[activePicturePosition - 1].caption"
                class="white--text text-caption text-truncate"
              ></div>
            </BaseSheet>
          </div>
        </div>
      </div>
    </div>
    <BasePicturesScroller
      v-if="post.pictures.length > 1"
      :picturesLength="post.pictures.length"
      :activePosition="activePicturePosition"
      class="mt-4"
    ></BasePicturesScroller>
    <ExperienceCardContent
      :title="post.title"
      :content="post.content"
      :themes="post.themes"
      :postType="post.type"
      :website="post.originWebsite"
      :postUrl="post.url"
      :ambiances="post.ambiances"
      :travellers="post.travellers"
      :activities="post.activities"
      :transports="post.transports"
    ></ExperienceCardContent>
    <ExperienceCardHeader
      v-if="post.type == 'picture_post'"
      :username="post.creator.user"
      :dense="true"
      :avatarPicture="
        post.creator.profilePicture ? post.creator.profilePicture.small : ''
      "
      :avatarSize="30"
      :season="post.season"
      :postIsEditable="postIsEditable"
      @manage-post="$store.dispatch('share/manageSharePost', post)"
    ></ExperienceCardHeader>
  </BaseCard>
</template>

<script>
import ExperienceCardHeader from "./ExperienceCardHeader";
import ExperienceCardContent from "./ExperienceCardContent";

export default {
  name: "BaseExperienceCard",
  components: {
    ExperienceCardHeader,
    ExperienceCardContent
  },
  // DATAs
  props: {
    post: {
      type: Object,
      required: true
    },
    postIsEditable: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      activePicturePosition: 1,
      isContentHover: false,
      youtubePlayer: null,
      youtubePlayerHasBeenCharged: false,
      isYoutubePlayerDisplayed: false,
      titleSize: "16",
      contentMarginBottom: "54"
    };
  },
  computed: {
    origin() {
      return window.location.origin;
    }
  },
  // METHODS
  methods: {
    changeActivePicture(newActivePicturePosition) {
      this.activePicturePosition = newActivePicturePosition;
    },
    youtubeVideoIsReady(event) {
      this.youtubePlayer = event.target;
      this.youtubePlayerHasBeenCharged = true;
    },
    playYoutubeVideo() {
      this.isYoutubePlayerDisplayed = true;
      this.youtubePlayer.playVideo();
    },
    youtubeVideoHasBeenPaused() {
      this.isYoutubePlayerDisplayed = false;
    }
  }
};
</script>
<style lang="css" scoped>
.image-wrapper {
  position: relative;
  padding-top: 100%;
  width: 100%;
}
.image-wrapper-content {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.transition-property--opacity {
  transition-property: opacity;
  -moz-transition-property: opacity;
  -o-transition-property: opacity;
  -webkit-transition-property: opacity;
}
.card-content {
  transition-property: background-color;
  -moz-transition-property: background-color;
  -o-transition-property: background-color;
  -webkit-transition-property: background-color;
}
.background-color--black-20 {
  background-color: rgba(0, 0, 0, 0.2);
}
.background-color--transparent {
  background-color: rgba(0, 0, 0, 0);
}
</style>
